import { paymentMethodsList } from '@/api/global';
import PriceSection from '@/components/pages/wallet/WalletContent/WalletInfo/PriceSection';
import { useLayoutContext } from '@/context/LayoutContext';
import { avatarBg } from '@/functions/formats';
import React from 'react';
import styles from '../styles.module.css';
import RadioOption from '../RadioOption';
import PageCardHeader from '@/components/general/PageCard/PageCardHeader';
import MainIcons from '@/icons/main';
import ReserveSectionHead from '../ReserveSectionHead';
import { ReserveInfo } from '@/commonTypes';
import AppointmentSummary from '../AppointmentSummary';

export default function ReservePaymentLevel({
  info,
  onChange,
  timeSlots,
}: {
  onChange: (value: any, key: string) => void;
  info?: ReserveInfo;
  timeSlots?: { id?: number; time?: string; state?: string }[];
}) {
  const { walletInfo, editInfo } = useLayoutContext();
  const servicePlaceList = [
    {
      id: 1,
      title: 'در تعمیرگاه',
      text: editInfo?.item?.shop?.name,
      bg: 'var(--tag-bg)',
      icon: <MainIcons.shopIcon fill={'var(--brand-deep)'} width="22px" height="22px" />,
      aside: <span className={`${styles.freePrice}`}>رایگان</span>,
    },
    {
      id: 2,
      title: 'خدمت در محل شما (سیار)',
      text: editInfo?.item?.shop?.name,
      bg: 'var(--purple-bg)',
      icon: <MainIcons.homeIcon fill={'var(--purple)'} width="22px" height="22px" />,
      aside: <span>-</span>,
      disabled: true,
    },
  ];
  const paymentList = [
    {
      id: paymentMethodsList?.wallet,
      title: 'کیف پول کارا',
      text: (
        <PriceSection className={styles.wallet} prefix={'موجودی'} value={walletInfo?.balance} />
      ),
      bg: avatarBg(8),
      color: 'var(--danger)',
      aside: undefined,
      disabled: false,
    },
    {
      id: paymentMethodsList?.bank,
      title: 'پرداخت آنلاین',
      text: 'انتقال به درگاه بانکی امن',
      bg: avatarBg(6),
      color: 'var(--purple)',
      aside: undefined,
      disabled: false,
      icon: null,
    },
  ];
  return (
    <div className={`${styles.reservePaymentContainer}`}>
      <ReserveSectionHead title={`محل انجام خدمت`} />
      {servicePlaceList?.map((item, index) => (
        <RadioOption
          item={item}
          key={index}
          title={item?.title}
          active={info?.location == item?.id}
          onClick={(x) => {
            onChange(x?.id, 'location');
          }}
          aside={item?.aside}
          disabled={item?.disabled}
          error={info?.messages?.location}
          showError={info?.error?.location}
        >
          <PageCardHeader
            key={index}
            title={item?.title}
            text={item?.text}
            icon={item?.icon}
            iconClass={`${styles.itemIconClass}`}
            titleClass={`${styles.radioTitleClass}`}
            textClass={`${styles.radioTextClass}`}
            backgroundIcon={item?.bg}
          />
        </RadioOption>
      ))}
      {info?.error?.location && info?.messages?.location && (
        <p className={`inputErrorText`}>{info?.messages?.location}</p>
      )}
      <ReserveSectionHead title={`روش پرداخت`} />
      {paymentList?.map((item, index) => (
        <RadioOption
          item={item}
          key={index}
          title={item?.title}
          active={info?.paymentMethod == item?.id}
          onClick={(x) => {
            onChange(x?.id, 'paymentMethod');
          }}
          aside={item?.aside}
          disabled={item?.disabled}
          error={info?.messages?.paymentMethod}
          showError={info?.error?.paymentMethod}
        >
          <PageCardHeader
            key={index}
            title={item?.title}
            text={item?.text}
            icon={item?.icon}
            iconClass={`${styles.itemIconClass}`}
            titleClass={`${styles.radioTitleClass}`}
            textClass={`${styles.radioTextClass}`}
            backgroundIcon={item?.bg}
          />
        </RadioOption>
      ))}
      {info?.error?.paymentMethod && info?.messages?.paymentMethod && (
        <p className={`inputErrorText`}>{info?.messages?.paymentMethod}</p>
      )}

      <AppointmentSummary
        info={info}
        activeTime={timeSlots?.filter((x) => x.id == info?.time)?.[0]?.time}
      />
    </div>
  );
}
